import {FETCH_POSTS_FAILURE, FETCH_POSTS_REQUEST, FETCH_POSTS_SUCCESS} from '../actions';


interface PostState {
  posts: any[];
  loading: boolean;
  error: string | null;
}

const initialState: PostState = {
  posts: [],
  loading: false,
  error: null
}

const postsReducer = (state= initialState, action: any)  => {
  switch(action.type){
    case FETCH_POSTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }
    case FETCH_POSTS_SUCCESS:
      return {
        ...state,
        posts: action.payload,
        loading: false,
      }
    case FETCH_POSTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    default:
      return state;
  }
}

export default postsReducer;